import React from "react";

function SanctionLoanCancellation() {
    return (
        <>
            <div className="relative w-full">
                <p className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1">
                    In the event of cancellation, interest charges will be borne
                    by the customer. Processing Fee, Stamp Duty and RTO Charges
                    (Used Car Purchase / Refinance / Rewards) are non-
                    refundable charges and would not be waived/refunded in case
                    loan cancellation.
                </p>
            </div>
        </>
    );
}

export default SanctionLoanCancellation;
